import { call, put, takeEvery } from 'redux-saga/effects';

import Api from '../lib/Api';

import { FETCH_CITIES_REQUESTED } from '../store/cities/actionTypes';
import {
  fetchCitiesFailed,
  fetchCitiesSucceeded
} from '../store/cities/actions';

const _getCitiesRequested = () => {
  return Api.getCitiesList()
    .then((response) => response)
    .catch((e) => e.response);
};

function* fetchCities() {
  try {
    const response = yield call(_getCitiesRequested);
    yield put(fetchCitiesSucceeded({ cities: response.data.data }));
  } catch (error) {
    yield put(fetchCitiesFailed(error));
  }
}

function* CitiesSaga() {
  yield takeEvery(FETCH_CITIES_REQUESTED, fetchCities);
}

export default CitiesSaga;



// WEBPACK FOOTER //
// ./src/saga/cities.js